const downsizeCurrencySymbols = () => {
    const priceItems = document.querySelectorAll('.text-subdued, .text-end, .text-lg, .price__regular, .price__sale, .visually-hidden, .totals__total-value, .product-option, .price, .swym-storefront-layout-grid-item-final-price, .shipping-yen');
    
    priceItems.forEach((priceItem) => {
        if (priceItem.classList.contains('downsized')) return;

        // ¥がすでに <span class="mini-symbol"> で囲まれていないかチェック
        if (!priceItem.innerHTML.includes('<span class="mini-symbol">')) {
            priceItem.innerHTML = priceItem.innerHTML.replace(/¥(?!<\/span>)/g, '<span class="mini-symbol">¥</span>');
        }

        priceItem.classList.add('downsized');
    });
};

window.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutationsList, observer) => {
        observer.disconnect();
        downsizeCurrencySymbols(); 
        observer.observe(document.body, config);
    });

    const config = {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
    };

    downsizeCurrencySymbols();
    observer.observe(document.body, config);
});
